import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { FaApple, FaGooglePlay } from "react-icons/fa";

const Countdown = () => {
  const targetDate = new Date("2025-05-01T00:00:00").getTime();
  const [timeLeft, setTimeLeft] = useState(getTimeLeft());

  function getTimeLeft() {
    const now = new Date().getTime();
    const difference = targetDate - now;
    
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((difference % (1000 * 60)) / 1000),
    };
  }

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center w-full bg-primaryOrange p-6 rounded-lg shadow-strong">
      <h1 className="text-2xl md:text-3xl font-bold mb-4 text-primaryWhite text-center uppercase">
        Greetli Launches In 🚀 :
      </h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center p-4 rounded-lg shadow-medium bg-darkOrange w-full max-w-lg mt-4">
        {Object.entries(timeLeft).map(([unit, value]) => (
          <motion.div
            key={unit}
            className="flex flex-col justify-center items-center p-4 md:p-5 bg-primaryWhite rounded-lg text-2xl md:text-3xl font-bold shadow-md text-primaryBlack w-full h-20 md:h-24"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {value}
            <div className="text-xs md:text-sm text-primaryGrey uppercase mt-1">{unit}</div>
          </motion.div>
        ))}
      </div>
      <div className="flex flex-col items-center mt-2">
        <p className="text-primaryWhite text-lg uppercase">on</p>
        <div className="flex items-center space-x-3 mt-4">
          <div className="bg-primaryWhite w-[155px] h-[44px] rounded-md flex justify-center items-center shadow-lg text-primaryOrange font-bold text-xl space-x-1">
            <FaApple size={25} />
            <p>App store</p>
          </div>
          <div className="bg-primaryWhite w-[155px] h-[44px] rounded-md flex justify-center items-center shadow-lg text-primaryOrange font-bold text-xl space-x-1">
            <FaGooglePlay />
            <p>Google play</p>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Countdown;